import { createParsedLocalStorageField } from '@ipfabric/ui-components/utils/localStorageField';
import { nullable } from '@ipfabric/utils/fp/nullable';

export const refreshTokenExpirationLocalStorage = createParsedLocalStorageField<
  number | null
>(
  'refreshTokenExpiresAt',
  nullable.map(Number),
  nullable.map((num) => num.toString()),
);
